// frontend/src/components/conversation/campMergedState.ts
import type { Message } from '../../contexts/ConversationContext';

/**
 * Camp ids (spine_root_message_id) that a host-authored fold (council_merge OR
 * C2.3 council_switchback) has folded back onto the spine. Build-time,
 * server-truth — recomputed on every reload, so a reconnect mid-merge self-heals
 * (mirrors campArrivalState's derivation).
 */
// C2.3 — a forward merge and a switchback both fold a Camp (spec §0.1 B1).
const FOLD_KINDS = new Set(['council_merge', 'council_switchback']);

export function collectMergedCampIds(messages: Message[]): Set<string> {
  const ids = new Set<string>();
  for (const mm of messages) {
    if (!FOLD_KINDS.has((mm.metadata as any)?.kind)) continue;
    for (const entry of ((mm.metadata as any)?.merged_from ?? [])) {
      if (entry?.camp_id) ids.add(entry.camp_id);
    }
  }
  return ids;
}
